import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminAttemptDetail = {
  pageTitle: "Attempt Detail",
  notFound: "No matching attempt record was found.",
  sections: {
    summary: "Attempt Summary",
    deliverySnapshot: "Delivery Snapshot",
    scoreRecords: "Score Records",
    judgeSubmissions: "Code Submissions",
    environments: "Environment Instances",
  },
  fields: {
    paperTitle: "Paper Name",
    paperType: "Paper Type",
    paperVersionCode: "Paper Version Code",
    duration: "Exam Duration",
    examStartTime: "Exam Start Time",
    examEndTime: "Exam End Time",
    deadlineAt: "Attempt Deadline",
    earliestSubmitAt: "Earliest Submit Time",
    exam: "Exam",
    candidate: "Candidate",
    status: commonShortNouns.status,
    reviewStatus: "Review Status",
    totalScore: "Total Score",
    scoreSplit: "Objective / Subjective",
    startedAt: "Started At",
    submittedAt: "Submitted At",
    lastSavedAt: "Last Saved",
    createdAt: commonShortFieldLabels.createdAt,
    questionId: "Question ID",
    questionCode: "Question Code",
    versionId: "Question Version ID",
    versionCode: "Version Code",
    questionType: "Question Type",
    difficulty: "Difficulty",
    questionScore: "Question Score",
    source: "Source",
    scoreSource: "Score Source",
    score: "Score",
    comment: "Comment",
    time: "Time",
    submission: "Submission",
    judgeStatus: "Judge Status",
    instance: "Instance",
    type: "Type",
    accessEntry: "Access Entry",
  },
  labels: {
    questionTitle: "Question {order} · {title}",
    titleWithId: "Attempt #{id}",
    sourceAuto: "Auto Scoring",
    sourceManual: "Manual Scoring",
    sourceReview: "Review Scoring",
    sourceUnknown: "Unknown Source",
    statusValid: "Valid",
    statusInvalid: "Invalid",
    statusPending: "Pending",
    statusUnknown: "Unknown",
    commentAutoObjective: "System auto-scored objective question",
    commentManualReview: "Manual review scoring",
    examFallback: "Exam #{id}",
    candidateFallback: "Candidate #{id}",
    candidateId: "ID {id}",
    contentRef: "content_ref: {value}",
    policyShuffleQuestions: "Shuffle questions {value}",
    policyShuffleOptions: "Shuffle options {value}",
    policySelfCheck: "Self check {value}",
    policyMaxSelfCheckCount: "Run up to {count} times",
    policyMaxCreateCount: "Create up to {count} environments",
    markCorrect: "Correct",
    markCorrectRadioTip: "(Click the radio button on the left to mark it as the correct answer)",
    markCorrectCheckboxTip: "(Check the checkbox on the left to mark it as a correct answer)",
    practicalQuestionFallback: "Practical Question Debugging",
    attackDefenseQuestionFallback: "Attack-Defense Question Debugging",
  },
  actions: {
    viewExam: "View Exam",
    viewRawJson: "View Raw JSON",
    viewLatestAnswerJson: "View Attempt Raw JSON",
    viewReferenceAnswerJson: "View Reference Answer Raw JSON",
    viewQuestionSnapshotJson: "View Question Snapshot Raw JSON",
  },
  cards: {
    runtimePolicies: "Question Runtime Policies",
    questionSnapshotAndAnswer: "Question Snapshot and Answer",
    questionPreview: "Question Preview",
    runtimePolicy: "Runtime Policy",
    answerResult: "Answer Result",
    referenceAnswer: "Reference Answer",
  },
} as const;
